/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, {useState, useEffect} from 'react'
import {useTranslation} from 'react-i18next'
import {getScheduleOrder} from '../../../api/modules/order'
import i18next from 'i18next'
import Skeleton from 'react-loading-skeleton'

function AddRemoveJadwal({id, is_amendment, tipeproduct = '', unit = ''}) {
  const [listJadwal, setListJadwal] = useState([])
  const [i, seti] = useState(1)
  const [allJadwal, setAllJadwal] = useState([])
  const [taking, setTaking] = useState(1)
  const [loadingSkeleton, setLoadingSkeleton] = useState(false)

  const [inputFields, setInputFields] = useState([
    {
      education_name: '',
      from_date: '',
      till_date: '',
      department: '',
      qualification: '',
      ijazah: '',
    },
  ])

  const bulan = [
    'Januari',
    'Februari',
    'Maret',
    'April',
    'Mei',
    'Juni',
    'Juli',
    'Agustus',
    'September',
    'Oktober',
    'November',
    'Desember',
  ]

  const addInputField = () => {
    setInputFields([
      ...inputFields,
      {
        education_name: '',
        from_date: '',
        till_date: '',
        department: '',
        qualification: '',
        ijazah: '',
      },
    ])
  }

  const removeInputFields = (index) => {
    const temp = listJadwal
    temp.splice(index)
    setListJadwal(temp)
    const rows = [...inputFields]
    rows.splice(index, 1)
    setInputFields(rows)
  }

  const handleChange = (index, evnt) => {
    const {name, value} = evnt.target
    const list = [...inputFields]
    list[index][name] = value
    setInputFields(list)
  }

  const {t} = useTranslation()

  const getJadwal = async () => {
    setLoadingSkeleton(true)
    const res = await getScheduleOrder(id, is_amendment).then((res) => {
      setAllJadwal(res.data.data.schedules)
    })
    setLoadingSkeleton(false)
    setTaking(allJadwal[allJadwal.length - 1].sort)
  }

  useEffect(() => {
    getJadwal()
  }, [])

  return (
    <>
      <span style={{fontSize: '15px'}} className='fw-bold d-block'>
        {t('Jadwal')}
      </span>
      <div className='table-responsive bdr'>
        {loadingSkeleton ? (
          // <div className='text-center fs-4 fw-semibold'>
          //   <Skeleton height={30}/>
          // </div>
          <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
            <tbody className=''>
              <tr className='d-flex'>
                <td style={{width: '167px'}} className='text-center'>
                  <Skeleton width={100} height={30} />
                </td>
                <td style={{width: '185.5px'}} className='text-center'>
                  <Skeleton width={100} height={30} />
                </td>
                <td style={{width: '185.5px'}} className='text-center'>
                  <Skeleton width={100} height={30} />
                </td>
                <td style={{width: '185.5px'}} className='text-center'>
                  <Skeleton width={100} height={30} />
                </td>
                <td style={{width: '185.5px'}} className='text-center'>
                  <Skeleton width={100} height={30} />
                </td>
                <td style={{width: '185.5px'}} className='text-center'>
                  <Skeleton width={100} height={30} />
                </td>
              </tr>
            </tbody>
          </table>
        ) : (
          <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
            <thead className='border-bottom'>
              <tr className='fw-bold d-flex'>
                <th style={{width: '167px'}} className='text-center'>
                  {t('order-pengambilan')}
                </th>
                <th style={{width: '185.5px'}} className='text-center'>
                  {t('order-tanggal')}
                </th>
                <th style={{width: '185.5px'}} className='text-center'>
                  {t('order-minggu')}
                </th>
                <th style={{width: '185.5px'}} className='text-center'>
                  {t('order-bulan')}
                </th>
                <th style={{width: '185.5px'}} className='text-center'>
                  {t('order-tahun')}
                </th>
                <th style={{width: '185.5px'}} className='text-center'>
                  {tipeproduct != '8105' ? t('order-tonase') : t('sack')}
                </th>
              </tr>
            </thead>
            {allJadwal.map((data, _index) => (
              <tbody key={_index}>
                <tr className='d-flex'>
                  <td style={{width: '167px'}} className='text-center'>
                    <label>{_index + 1}</label>
                  </td>
                  <td style={{width: '185.5px'}} className='text-center'>
                    <label>{data.date}</label>
                  </td>
                  <td style={{width: '185.5px'}} className='text-center'>
                    <label>
                      {t('Week')}
                      {Math.ceil(data.date / 7)}
                    </label>
                  </td>
                  <td style={{width: '185.5px'}} className='text-center'>
                    <label>{t(bulan[data.month - 1])}</label>
                  </td>
                  <td style={{width: '185.5px'}} className='text-center'>
                    <label>{data.year}</label>
                  </td>
                  <td style={{width: '185.5px'}} className='text-center'>
                    <label>
                      {i18next.language === 'en'
                        ? data.tonnage.toLocaleString('en', {maximumFractionDigits: 4})
                        : data.tonnage.toLocaleString('id', {maximumFractionDigits: 4})}{' '}
                      {tipeproduct != '8105' ? 'Ton' : unit}
                    </label>
                  </td>
                </tr>
              </tbody>
            ))}
          </table>
        )}
      </div>
    </>
  )
}
export default AddRemoveJadwal
